<template>
  <!-- Header -->
  <div class="header" id="heading" style="background-color: #f6f6f6">
    <!-- Logo -->
    <div class="header-left" v-if="!isMobile" style="background-color: #fff">
      <router-link to="/profile" class="logo">
        <img
          :src="img"
          height="50px"
          alt="Logo"
          class="sidebar-logo"
          style="width: 100%"
        />
        <img
          :src="img"
          height="100%"
          alt="Logo"
          class="mini-sidebar-logo"
          style="width:200px;"
        />
      </router-link>
    </div>
    <div
      class="header-left"
      v-if="isMobile"
      style="text-align: center; background-color: #fff"
    >
      <router-link to="/profile" class="logo">
        <img :src="img" height="50px" alt="Logo" class="sidebar-logo" />
      </router-link>
    </div>
    <!-- /Logo -->

    <a id="toggle_btn" href="javascript:void(0);">
      <div style="border-radius: 0px 5px 5px 0px;
border-top: 1px solid #DFDFDF;

border-right: 1px solid #DFDFDF;

border-bottom: 1px solid #DFDFDF;

background: #FFF;">
 <v-icon color="primary">mdi-chevron-right</v-icon></div>
   
    </a>

    <!-- Header Title --->
    <div class="page-title-box">
      <div class="top-nav-search">
        <a href="javascript:void(0);" class="responsive-search">
          <i class="fa fa-search"></i>
        </a>
        <!-- <form action="search">
            <input class="form-control" type="text" placeholder="Search here">
            <button class="btn" type="submit"><i class="fa fa-search"></i></button>
          </form> -->
      </div>
    </div>
    <!-- /Header Title -->

    <a id="mobile_btn" class="mobile_btn"><i class="fa fa-bars"></i></a>

    <!-- Header Menu -->
    <ul class="nav user-menu">
      <!-- Search -->
      <li class="nav-item">
        <v-btn hidden id="theme" icon @click="toggle_dark_mode">
          <v-icon>mdi-theme-light-dark</v-icon>
        </v-btn>
      </li>
      <!-- /Search -->

      <!-- Flag
      <li class="nav-item dropdown has-arrow flag-nav">
        <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button">
          <img src="@/assets/img/flags/us.png" alt="" height="20"> <span>English</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/img/flags/us.png" alt="" height="16"> English
          </a>
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/img/flags/fr.png" alt="" height="16"> French
          </a>
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/img/flags/es.png" alt="" height="16"> Spanish
          </a>
          <a href="javascript:void(0);" class="dropdown-item">
            <img src="@/assets/img/flags/de.png" alt="" height="16"> German
          </a>
        </div>
      </li>
      /Flag -->

      <!-- Notifications -->
      <li hidden class="nav-item dropdown">
        <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
          <i class="fa fa-bell-o"></i>
          <!-- <span class="badge badge-pill">3</span> -->
        </a>
        <div class="dropdown-menu notifications">
          <div class="topnav-dropdown-header">
            <span class="notification-title">Notifications</span>
            <a href="javascript:void(0)" class="clear-noti">Clear All</a>
          </div>
          <div class="noti-content">
            <ul class="notification-list">
              <!--
              <li class="notification-message">
                <router-link to="/activities">
                  <div class="media">
                    <span class="avatar">
                      <img alt="" src="@/assets/img/profiles/avatar-02.jpg">
                    </span>
                    <div class="media-body">
                      <p class="noti-details"><span class="noti-title">John Doe</span> added new task <span class="noti-title">Patient appointment booking</span></p>
                      <p class="noti-time"><span class="notification-time">4 mins ago</span></p>
                    </div>
                  </div>
                </router-link>
              </li>
              -->
            </ul>
          </div>
          <div class="topnav-dropdown-footer">
            <!--- <router-link to="/activities">View all Notifications</router-link> -->
          </div>
        </div>
      </li>
      <!-- /Notifications -->

      <!-- Message Notifications
      <li class="nav-item dropdown">
        <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
          <i class="fa fa-comment-o"></i> <span class="badge badge-pill">8</span>
        </a>
        <div class="dropdown-menu notifications">
          <div class="topnav-dropdown-header">
            <span class="notification-title">Messages</span>
            <a href="javascript:void(0)" class="clear-noti"> Clear All </a>
          </div>
          <div class="noti-content">
            <ul class="notification-list">
              <li class="notification-message">
                <a href="#">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img alt="" src="@/assets/img/profiles/avatar-09.jpg">
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author">Richard Miles </span>
                      <span class="message-time">12:28 AM</span>
                      <div class="clearfix"></div>
                      <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                    </div>
                  </div>
                </a>
              </li>
              <li class="notification-message">
                <a href="#">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img alt="" src="@/assets/img/profiles/avatar-02.jpg">
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author">John Doe</span>
                      <span class="message-time">6 Mar</span>
                      <div class="clearfix"></div>
                      <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                    </div>
                  </div>
                </a>
              </li>
              <li class="notification-message">
                <a href="#">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img alt="" src="@/assets/img/profiles/avatar-03.jpg">
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author"> Tarah Shropshire </span>
                      <span class="message-time">5 Mar</span>
                      <div class="clearfix"></div>
                      <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                    </div>
                  </div>
                </a>
              </li>
              <li class="notification-message">
                <a href="#">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img alt="" src="@/assets/img/profiles/avatar-05.jpg">
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author">Mike Litorus</span>
                      <span class="message-time">3 Mar</span>
                      <div class="clearfix"></div>
                      <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                    </div>
                  </div>
                </a>
              </li>
              <li class="notification-message">
                <a href="#">
                  <div class="list-item">
                    <div class="list-left">
                      <span class="avatar">
                        <img alt="" src="@/assets/img/profiles/avatar-08.jpg">
                      </span>
                    </div>
                    <div class="list-body">
                      <span class="message-author"> Catherine Manseau </span>
                      <span class="message-time">27 Feb</span>
                      <div class="clearfix"></div>
                      <span class="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div class="topnav-dropdown-footer">
            <a href="#">View all Messages</a>
          </div>
        </div>
      </li>
      /Message Notifications -->
      <!-- 
 <img  style="height: 70px;" src="https://srcwap.com/wp-content/uploads/2019/12/Happy-New-Year-2020-Photos-Pics-Pictures.gif"/>
 -->
      <li class="nav-item dropdown has-arrow main-drop">
        <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
          <!--  <span class="user-img"><img src="@/assets/img/profiles/avatar-21.jpg" alt=""> -->

          <!---     <span class="status online"></span> <span style="color:#DFDFDF width:300px; height:50px; top: 0px;">Welcome!</span><br>-->
          <span
            class="font-weight-bold mb-0"
            style="top:45px; color: #000 width:200px; height:17px; font-family:Roboto; font-weight:300%; font-size:16px;"
            >{{ username }}</span
          >
          <v-avatar>
          <img
            style="height: 40px; width: 40px"
            v-if="checkuserimg(userimage)"
            :src="userimage"
          /></v-avatar>
          <v-avatar color="blue" v-if="checkimg(userimage)">
            <div style="font-size: 24px">
              {{ username.substring(0, 1) }}
            </div>
          </v-avatar>
        </a>
        <div class="dropdown-menu">
          <router-link hidden class="dropdown-item" to="/profile">
            My Profile
          </router-link>
          <router-link class="dropdown-item" to="/changepassword">
            Change Password
          </router-link>

          <router-link class="dropdown-item" to="/login" @click.native="logOut">
            Logout
          </router-link>
        </div>
      </li>
    </ul>
    <!-- /Header Menu -->

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a
        href="#"
        class="nav-link dropdown-toggle"
        data-toggle="dropdown"
        aria-expanded="false"
      >
        <i class="fa fa-ellipsis-v"></i>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" to="/changepassword">
          Change Password
        </router-link>
        <router-link class="dropdown-item" to="/login" @click.native="logOut">
          Logout
        </router-link>
      </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
  <!-- /Header -->
</template>
<script>
const BASE_API = require("../service/prod.env");
import axios from "axios";
export default {
  data() {
    return {
      user: "",
      img: "",
      isMobile: false,
      userimage: "",
      username: "",
    };
  },
  methods: {
    checkuserimg(img) {
      if (img.length > 22) {
        return true;
      } else {
        return false;
      }
    },
    checkimg(img) {
      if (img === "data:image/jpg;base64," || img === 0) {
        return true;
      } else {
        return false;
      }
    },
    themedark() {
      var headerColors1 = `theme-default black-mode header-solid-pink header-solid-orange header-solid-purple header-solid-blue header-solid-green
    header-gradient-color1  header-gradient-color2 header-gradient-color3 header-gradient-color4 header-gradient-color5 header-gradient-color6
    header-gradient-color7 header-solid-black  `;
      var headerColors = `theme-default black-mode theme-orange theme-blue theme-grey theme-lgrey theme-dblue theme-pink
    theme-purple theme-solid-pink theme-solid-orange theme-solid-purple theme-solid-blue theme-solid-green
     header-orange header-blue header-grey header-lgrey header-dblue header-pink
    header-purple theme-dark theme-solid-black`;
      var sidebarColors2 = `theme-default black-mode sidebar-solid-pink sidebar-solid-orange sidebar-solid-purple sidebar-solid-blue sidebar-solid-green
    sidebar-gradient-color1  sidebar-gradient-color2 sidebar-gradient-color3 sidebar-gradient-color4 sidebar-gradient-color5 sidebar-gradient-color6
    sidebar-gradient-color7  sidebar-solid-black`;
      $(document).ready(function () {
        var navColor = localStorage.getItem("navbar-color");
        if (navColor) {
          $("body").removeClass(headerColors).addClass(navColor);
        }
      });
      $(document).ready(function () {
        var navColor1 = localStorage.getItem("navbar-color1");
        if (navColor1) {
          $("body").removeClass(headerColors1).addClass(navColor1);
        }
      });
      $(document).ready(function () {
        var navColor2 = localStorage.getItem("navbar-color2");
        if (navColor2) {
          $("body").removeClass(sidebarColors2).addClass(navColor2);
        }
      });
      $("body").removeClass(headerColors1).addClass("header-solid-black");
      localStorage.setItem("navbar-color1", "header-solid-black");
      $("body").removeClass(headerColors).addClass("sidebar-solid-black");
      localStorage.setItem("navbar-color", "theme-default");
      $("body").removeClass(sidebarColors2).addClass("sidebar-solid-black");
      localStorage.setItem("navbar-color2", "sidebar-solid-black");
    },
    themeLight() {
      var headerColors1 = `theme-default black-mode header-solid-pink header-solid-orange header-solid-purple header-solid-blue header-solid-green
    header-gradient-color1  header-gradient-color2 header-gradient-color3 header-gradient-color4 header-gradient-color5 header-gradient-color6
    header-gradient-color7 header-solid-black  `;
      var headerColors = `theme-default black-mode theme-orange theme-blue theme-grey theme-lgrey theme-dblue theme-pink
    theme-purple theme-solid-pink theme-solid-orange theme-solid-purple theme-solid-blue theme-solid-green
     header-orange header-blue header-grey header-lgrey header-dblue header-pink
    header-purple theme-dark theme-solid-black`;
      var sidebarColors2 = `theme-default black-mode sidebar-solid-pink sidebar-solid-orange sidebar-solid-purple sidebar-solid-blue sidebar-solid-green
    sidebar-gradient-color1  sidebar-gradient-color2 sidebar-gradient-color3 sidebar-gradient-color4 sidebar-gradient-color5 sidebar-gradient-color6
    sidebar-gradient-color7  sidebar-solid-black`;
      $(document).ready(function () {
        var navColor1 = localStorage.getItem("navbar-color1");
        if (navColor1) {
          $("body").removeClass(headerColors1).addClass(navColor1);
        }
      });
      $("body").removeClass(headerColors1).addClass("theme-default");
      localStorage.setItem("navbar-color1", "theme-default");
      $("body").removeClass(headerColors).addClass("theme-default");
      localStorage.setItem("navbar-color", "theme-default");
      $("body").removeClass(sidebarColors2).addClass("theme-default");
      localStorage.setItem("navbar-color2", "theme-default");
    },
    logOut: function () {
      axios
        .post(
          BASE_API.NODE_ENV + "/invalidate",
          {},
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("user")),
            },
          }
        )
        .then((res) => {
          localStorage.removeItem("user");
          localStorage.removeItem("AD_Client_ID");
          localStorage.removeItem("AD_Org_ID");
          localStorage.removeItem("AD_Role_ID");
          localStorage.removeItem("AD_Session_ID");
          localStorage.removeItem("AD_User_ID");
          localStorage.removeItem("AD_Warehouse_ID");
          localStorage.removeItem("Name");
          localStorage.removeItem("selectedVessel");
          localStorage.removeItem("companylogo");
          localStorage.removeItem("doc");
          this.$router.push("/");
        });
    },
    toggle_dark_mode: function () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      if (!this.$vuetify.theme.dark) this.themeLight();
      else this.themedark();
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    },
  },
  mounted() {
    this.userimage = JSON.parse(localStorage.getItem("userimage"));
    console.log("console", this.userimage);
    this.username = JSON.parse(localStorage.getItem("username"));
    if (window.innerWidth < 769) this.isMobile = true;
    else this.isMobile = false;
    this.themeLight();
    this.user = JSON.parse(localStorage.getItem("role"));
    this.img = JSON.parse(localStorage.getItem("companylogo"));
    console.log("logo", this.img);
    const theme = localStorage.getItem("dark_theme");
    if (theme) {
      if (theme === "true") {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    } else if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      this.$vuetify.theme.dark = true;
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    }
    this.$vuetify.theme.dark = false;
    this.themeLight();
    // Variables declarations
    var $wrapper = $(".main-wrapper");
    var $pageWrapper = $(".page-wrapper");
    var $sidebarOverlay = $(".sidebar-overlay");
    // Small Sidebar
    if (screen.width >= 1000) {
      $(document).on("click", "#toggle_btn", function () {
        if ($("body").hasClass("mini-sidebar")) {
          $("body").removeClass("mini-sidebar");
          $(".subdrop + ul").slideDown();
        } else {
          $("body").addClass("mini-sidebar");
          $(".subdrop + ul").slideUp();
        }
        return false;
      });
      $(document).on("mouseover", function (e) {
        e.stopPropagation();
        if (
          $("body").hasClass("mini-sidebar") &&
          $("#toggle_btn").is(":visible")
        ) {
          var targ = $(e.target).closest(".sidebar").length;
          if (targ) {
            $("body").addClass("expand-menu");
            $(".subdrop + ul").slideDown();
          } else {
            $("body").removeClass("expand-menu");
            $(".subdrop + ul").slideUp();
          }
          return false;
        }
      });
    }
    // Sidebar overlay
    function sidebar_overlay($target) {
      if ($target.length) {
        $target.toggleClass("opened");
        $sidebarOverlay.toggleClass("opened");
        $("html").toggleClass("menu-opened");
        $sidebarOverlay.attr("data-reff", "#" + $target[0].id);
      }
    }
    // Mobile menu sidebar overlay
    $(document).on("click", "#mobile_btn", function () {
      var $target = $($(this).attr("href"));
      sidebar_overlay($target);
      $wrapper.toggleClass("slide-nav");
      $("#chat_sidebar").removeClass("opened");
      return false;
    });
    // Mobile Menu
    $(document).on("click", "#open_msg_box", function () {
      $wrapper.toggleClass("open-msg-box");
      return false;
    });
    // Page wrapper height
    var pHeight = $(window).height();
    $pageWrapper.css("min-height", pHeight);
    $(window).resize(function () {
      var prHeight = $(window).height();
      $pageWrapper.css("min-height", prHeight);
    });
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue